import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../shared/local-storage.service';
import { TrawlDelivery } from '../shared/trawl-delivery.model';

@Component({
    selector: 'app-trawl-drafts',
    templateUrl: './trawl-drafts.component.html',
    styleUrl: './trawl-drafts.component.css',
    standalone: false
})
export class TrawlDraftsComponent {

  drafts: TrawlDelivery[] = [];
  draftsSubscription!: Subscription;
  user = LocalStorageService.current_user;
  
  
  constructor(public router: Router) { }
  
  ngOnInit(): void {
    LocalStorageService.storage_promise.then(_ => {
      this.drafts = LocalStorageService.trawl_drafts;
      console.log(this.drafts)
      this.draftsSubscription = LocalStorageService.trawl_drafts$.subscribe(val => this.drafts = val);    
    });
  }
  
   onDraftClick(index: number) {
      this.router.navigate(['trawl_delivery', 3, index], { queryParams: { previous: 'trawl_drafts' } })
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 0) window.scrollTo(0, 0);
    }
  
  
    ngOnDestroy(): void {
      if (this.draftsSubscription) this.draftsSubscription.unsubscribe();
    }
}
